<template>
  <div class="tabbar common-max-width">
    <div
      v-for="tab in tabList"
      :key="tab.name"
      class="tabbar-item"
      @click="tabClickHandler(tab.routeName)">
      <img
        v-if="tabIsActive(tab.routeName)"
        :src="require(`../assets/images/tabbar/${tab.active}`)" />
      <img
        v-else
        :src="require(`../assets/images/tabbar/${tab.noActive}`)" />
      <p :class="{ active : tabIsActive(tab.routeName)}">{{tab.name}}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'tabbar',
  data () {
    return {
      tabList: [
        { name: '首页', routeName: ['home'], active: 'homeActive.png', noActive: 'home.png' },
        { name: '排行', routeName: ['rank-page-view'], active: 'rankActive.png', noActive: 'rank.png' },
        { name: '发现', routeName: ['rank', 'artist', 'tags'], active: 'findActive.png', noActive: 'find.png' },
        { name: '我的', routeName: ['mine'], active: 'mineActive.png', noActive: 'mine.png' }
      ]
    }
  },
  methods: {
    tabIsActive (routerName) {
      return routerName.find(item => this.$route.name === item)
    },
    tabClickHandler (routerName) {
      this.$router.push({ name: routerName[0] })
    }
  }
}
</script>
<style scoped>
.tabbar {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  box-sizing: border-box;
  display: inline-flex;
  justify-content: space-around;
  width: 100%;
  height: 50px;
  padding: 5px 0;
  background-color: rgba(0, 0, 0, 0.9);
  border-top: 1px solid #999;
}

.tabbar-item {
  position: relative;
  width: 40px;
  text-align: center;
}

.tabbar-item img {
  width: 22px;
  height: 22px;
}

.tabbar-item p {
  width: 100%;
  padding: 0 0;
  margin: 0 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: rgba(153, 153, 153, 1);
  text-align: center;
}

.tabbar .tabbar-item .active {
  color: #d9cc54 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tabbar.vue